import React from 'react';

import { PRIME_OFFER_LINK } from 'application/pages/constants';

import IconHelpCircle from '@zvuk-b2b/react-uikit/ui/icons/HelpCircle';
import IconButton from '@zvuk-b2b/react-uikit/ui/IconButton';
import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import { TEXTS } from './texts';

import styles from './index.module.scss';

const DiscountHint = () => {
  const { isDesktop } = useMedia();

  const discountText = isDesktop ? TEXTS.PRIME_TITLE : '';
  const discountHintText = isDesktop ? TEXTS.PRIME_HINT : TEXTS.PRIME_TITLE;

  return (
    <div className={styles.discountBadge}>
      <span>{discountText}</span>
      <IconButton
        className={styles.discountHint}
        hintClassName={styles.discountHintText}
        elementId="discount_badge_hint"
        key="discount_badge_hint"
        hint={
          <>
            {discountHintText}
            <a
              target="_blank"
              rel="noopener noreferrer"
              className={styles.discountLink}
              href={PRIME_OFFER_LINK}>
              {TEXTS.PRIME_HINT_OFFER_LINK}
            </a>
          </>
        }>
        <IconHelpCircle />
      </IconButton>
    </div>
  );
};

export default React.memo(DiscountHint);
